// src/components/ErrorBoundary.tsx
import React from "react";
import { Alert, AlertTitle, styled } from "@mui/material";
import { jsx, jsxs } from "react/jsx-runtime";
var DebugInfo = styled("code")`
    display: block;
    padding: ${({ theme }) => theme.spacing(2)};
    margin: ${({ theme }) => theme.spacing(1.5)} 0 0;
    overflow: auto;
    pre {
        margin: 0;
        padding: 0;
        overflow: initial;
    }
`;
var ErrorBoundary = class extends React.PureComponent {
  state = {};
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    const { errorTitle = "Sorry, something went wrong.", children } = this.props;
    const { error } = this.state;
    if (!error) {
      return children;
    }
    const showErrorDetails = process.env.NODE_ENV === "development";
    return /* @__PURE__ */ jsxs(Alert, { severity: "error", children: [
      /* @__PURE__ */ jsx(AlertTitle, { children: errorTitle }),
      showErrorDetails ? /* @__PURE__ */ jsxs("p", { children: [
        /* @__PURE__ */ jsxs("b", { children: [
          error.message,
          ":"
        ] }),
        /* @__PURE__ */ jsx(DebugInfo, { children: /* @__PURE__ */ jsx("pre", { children: error.stack || JSON.stringify(error, null, 2) }) })
      ] }) : /* @__PURE__ */ jsx("div", { children: "Please try again." })
    ] });
  }
};
var ErrorBoundary_default = ErrorBoundary;

export {
  ErrorBoundary,
  ErrorBoundary_default
};
//# sourceMappingURL=chunk-LHUNKLMU.js.map